/**
 * Find highest child and add style for comparison table.
 */
export function comparisonTable() {
    const borderStyle = '1px solid #e5e5e5';
    const comparisons = document.querySelectorAll('.comparison-table__question-container');

    function findHighest($firstChild, $secondChild) {
        if ( $firstChild.clientHeight >= $secondChild.clientHeight ) {
            $firstChild.style.borderRight = borderStyle;
        } else {
            $secondChild.style.borderLeft = borderStyle;
        }
    }

    for (let i = 0; i < comparisons.length; i++) {
        const firstChild = comparisons[ i ].querySelector('.is-first');
        const secondChild = comparisons[ i ].querySelector('.is-second');

        findHighest(firstChild, secondChild);
    }
}

/**
 * Change dropdowns for selectize elements.
 * Selectize needs jQuery to work.
 */
export function serviceSearch() {
    let $serviceDropdown = jQuery('#service-search__service-dropdown');
    let $locationDropdown = jQuery('#service-search__location-dropdown');
    const serviceSelect = document.querySelector('#service-search__service-select');

    if (serviceSelect) {
        const latestService = localStorage.getItem( 'latest-service' );

        if (latestService) {
            serviceSelect.value = latestService;
        }
    }

    if ($serviceDropdown.length) {
        // Set up the select fields with selectize
        $serviceDropdown.selectize({
            placeholder: 'select a service',
            preload: true,
            valueField: 'slug',
            labelField: 'name',
            searchField: ['name', 'excerpt', 'keywords'],
            render: {
                option: function ( item, escape ) {
                    return '<div class="option">' +
                        '<span class="option-title">' + escape( item.name ) + '</span>' +
                        (item.excerpt ? '<span class="option-excerpt">' + escape( item.excerpt ) + '</span>' : '') +
                        (item.keywords ? '<span class="option-keywords">' + escape( item.keywords ) + '</span>' : '') +
                        '</div>';
                }
            },
            onInitialize: function () {
                this.$input.siblings('.loading-message').hide();
            }
        });

        let latestService = localStorage.getItem( 'latest-service' );
        let serviceDropdown = $serviceDropdown.get(0);

        loadDropdownOptions(latestService, serviceDropdown.selectize, setOption);
    }

    if ($locationDropdown.length) {
        // Clear reuslts on focus on service search sdebar only
        let clearResultsOnFocus = $locationDropdown.parents('.service-search-sidebar').length;
        
        // Set up the select fields with selectize
        $locationDropdown.selectize({
            onInitialize: function () {
                this.$input.siblings('.loading-message').hide();
            },
            onFocus: function () {
                if(clearResultsOnFocus) {
                    $locationDropdown[0].selectize.clear();
                }
            }
        });

        let latestLocation = localStorage.getItem('latest-location');
        let locationDropdown = $locationDropdown[ 0 ];

        loadDropdownOptions(latestLocation, locationDropdown.selectize, setOption);

        $locationDropdown.parents('form').submit(function(e) {
            if(!$locationDropdown.val().length) {
                e.preventDefault();
                // TODO: Give user feedback here that the form cannot be submitted
            }
        });
    }


    // Force load the options into the dropdown
    function loadDropdownOptions(option, dropdown, callback) {
        if (dropdown) {
            dropdown.refreshOptions(false);
            callback(option, dropdown);
        }
    }

    function setOption(option, dropdown) {
        if (option) {
            dropdown.addItem(option, false);
        }
    }

}



// WEBPACK FOOTER //
// ./src/js/pages.js